
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26.07 38.95"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M.85 7.86a1 1 0 01-.41-.25A1.23 1.23 0 010 6.74a1.3 1.3 0 01.32-1A16.57 16.57 0 013 3.34a16.52 16.52 0 016.47-3 17.2 17.2 0 017.19 0A16.53 16.53 0 0120 1.5a15.91 15.91 0 013.07 1.84 17.61 17.61 0 012.66 2.45 1.25 1.25 0 01.31 1 1.16 1.16 0 01-.44.87 1.25 1.25 0 01-.95.31 1.22 1.22 0 01-.89-.44 14.63 14.63 0 00-2.24-2.07 14.23 14.23 0 00-2.6-1.54 14.45 14.45 0 00-2.87-1 14.17 14.17 0 00-6.08 0A14.38 14.38 0 004.5 5.41a14.63 14.63 0 00-2.24 2.07 1 1 0 01-.44.34 1.29 1.29 0 01-.54.12 1.41 1.41 0 01-.43-.08z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M18.37 12.9a1.55 1.55 0 01-.46-.31 6 6 0 00-2.2-1.67 6.44 6.44 0 00-7.58 1.67 1.23 1.23 0 01-.88.44 1.3 1.3 0 01-1.38-1.21 1.25 1.25 0 01.31-1 9.1 9.1 0 013.09-2.24 9.05 9.05 0 017.53 0 9.16 9.16 0 013.08 2.29 1.31 1.31 0 01-.12 1.84 1.75 1.75 0 01-.42.23 1.32 1.32 0 01-.44.08 1.21 1.21 0 01-.53-.12zM18.34 15.72H7.73a1.66 1.66 0 00-1.66 1.66v19.91A1.66 1.66 0 007.73 39h10.61A1.66 1.66 0 0020 37.29V17.38a1.66 1.66 0 00-1.66-1.66zM13 25.59a3.1 3.1 0 113.1-3.09 3.09 3.09 0 01-3.1 3.09z"}})])])])
          )
        }
      }
    